import React from 'react';
import T from 'prop-types';
import TokenInput from 'shared/components/token-input';
import Field from 'shared/components/field';

const ShowTagField = ({
  onChange,
  meta,
  propName,
  label,
  restrictToOptions,
  placeholder,
  help,
  options,
  value,
}) => (
  <Field name={propName} label={label} meta={meta} help={help}>
    <TokenInput
      options={options}
      onChange={onChange}
      restrictToOptions={restrictToOptions}
      tokens={value}
      placeholder={placeholder}
    />
  </Field>
);

ShowTagField.propTypes = {
  onChange: T.func,
  meta: T.object,
  propName: T.string,
  label: T.string,
  restrictToOptions: T.bool,
  placeholder: T.string,
  help: T.string,
  options: T.array,
  value: T.any,
};

export default ShowTagField;
